import styled from '@emotion/styled'

import TemplateHeader from '@/components/templates/TemplateHeader'
import { TemplateButton } from '@/components/templates/TemplateButton'
import Subtitle from '@/components/templates/Subtitle'
import Title from '@/components/templates/Title'
import TemplateHero from '@/components/templates/TemplateHero'
import TemplateNavigation from '../../../components/templates/TemplateNavigation'

const Layout = styled.section``

Layout.Header = styled(TemplateHeader)`
  display: flex;
  height: 80px;
  width: 100%;
`

Layout.Logo = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`

Layout.LogoImage = styled.img`
  height: 70px;
  justify-self: flex-start;
`

Layout.LogoText = styled.span`
  font-size: 24px;
  font-weight: 700;
`

Layout.Navigation = styled(TemplateNavigation)`
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  align-items: center;
`

Layout.Link = styled.span`
  margin-left: 10px;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 15px;
`

Layout.Hero = styled(TemplateHero)``

Layout.HeroContainer = styled.div`
  display: flex;
  min-height: calc(var(--preview-height) - 80px);
  max-height: calc(var(--preview-height) - 80px);
  width: 100%;
  flex-wrap: wrap;
  z-index: 1;
  position: relative;
`

Layout.TitleContainer = styled.div`
  display: flex;
  flex-basis: 45%;
  flex-direction: column;
  flex-wrap: wrap;
  margin: auto 0;
  margin-top: 210px;
  z-index: 1;
`

Layout.Title = styled(Title)`
  font-size: 50px;
  font-weight: 700;
  font-family: ${({ fontFamily }) => fontFamily} !important;
`

Layout.Subtitle = styled(Subtitle)`
  font-size: 17px;
  font-weight: 400;
  margin: 1em 0;
  font-family: ${({ fontFamily }) => fontFamily} !important;
`
Layout.CTA = styled(TemplateButton)`
  width: fit-content;
  font-size: 16px;
  font-weight: 700;
  padding: 12px 30px;
  margin-top: 4em;
  border-radius: 0px;
  font-family: ${({ fontFamily }) => fontFamily} !important;
`

export default Layout
